export default function getFormattedNumber(value: number | string): string {
  if (!value) {
    return '';
  }

  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return numValue.toFixed(2);
}
